const therapistList = [
  { name: 'Akanksha Wagh', standard: 280, discount: 50 },
  { name: 'Alison Stevenson', standard: 480, discount: 80 },
  { name: 'Amit Vyas', standard: 360, discount: 65 },
  { name: 'Andreia Jennings', standard: 480, discount: 80 },
  { name: 'Bea Zanichelli', standard: 360, discount: 65 },
  { name: 'Billy Smith', standard: 280, discount: 50 },
  { name: 'Christine Everley', standard: 480, discount: 80 },
  { name: 'Cleo Irish-Zorrilla', standard: 280, discount: 50  },
  { name: 'Claire Feldman', standard: 480, discount: 80 },
  { name: 'David Cotson', standard: 560, discount: 70 },
  { name: 'Dr. Natascha Van Zyl', standard: 480, discount: 80 },
  { name: 'EJ Chalvert De Racy', standard: 280, discount: 50  },
  { name: 'Hillary Smith', standard: 400, discount: 70 },
  { name: 'James Lamper', standard: 600, discount: 80 },
  { name: 'Karen Baker', standard: 280, discount: 50 },
  { name: 'Maliha Salman', standard: 360, discount: 65 },
  { name: 'Maria Woodward', standard: 360, discount: 65 },
  { name: 'Maya Foulds', standard: 400, discount: 70 },
  { name: 'Murray Lindley', standard: 280, discount: 50 },
  { name: 'Patience Destiny', standard: 400, discount: 70 },
  { name: 'Paula Watson', standard: 360, discount: 65 },
  { name: 'Prof. Elizabeth Barley', standard: 480, discount: 70 },
  { name: 'Razeea Lemaignen', standard: 280, discount: 50 },
  { name: 'Sophie Demuth', standard: 480, discount: 80 },
  { name: 'Teri Spinks', standard: 280, discount: 50  }
];

const nutritionistList = [
  { name: 'Chloe Adam', standard: 450 },
  { name: 'Farah Younes', standard: 605 },
  { name: 'Helen West', standard: 605 },
  { name: 'Joy Skipper', standard: 515 },
  { name: 'Nese Targen', standard: 605 },
  { name: 'Olga Hamilton', standard: 605 },
  { name: 'Olivia Molyneux', standard: 450 },
  { name: 'Sue Camp', standard: 635 },
  { name: 'Susanna Fall', standard: 515 },
];

const mbList = [
  { name: 'Metabolic Balance', standard: 1100 },
  { name: 'Metabolic Balance Premium', standard: 1300 },
  { name: 'Metabolic Balance Platinum', standard: 1500 }
];

const timesGroup = [
  { value: 'standard', label: 'Standard' },
  { value: 'off-peak', label: 'Off-peak' }
];

const paymentGroup = [
  { value: 'one', label: 'One payment' },
  { value: 'installments', label: 'Installments' }
];

export {
  therapistList,
  nutritionistList,
  timesGroup,
  paymentGroup,
  mbList
}